import styled from 'styled-components'

export const SearchWraper = styled.div`
  max-width: 1430px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  flex: 1;
  padding: 5px 0 5px 29px;
  gap: 24px;
  position: relative;
  z-index: 1;
  .custom-select__control {
    height: 35px;
    min-height: 35px;
    border-radius: 2px;
  }
  @media (max-width: 1250px) {
    padding: 5px 0;
  }
  @media (max-width: 718px) {
    display: grid;
    grid-gap: 10px;
    .topbar-hide-mobile{
      display:none;
    }
  }
`;

export const SearchSection = styled.div`
  width: 100%;

  position: relative;
  z-index: 0;

  .type-ahead-search-input {
    > div input {
      height: 37px;
      border-radius: 5px;
      border: solid 1px #87cdf1;
    }
    .dropdown-menu .dropdown-item {
      padding: 10px 16px;
      font-size: 14px;
    }
    .seacrh-icon {
      margin: 0;
      height: 35px;
      position: absolute;
      cursor: pointer;
      right: 0;
    }
  }
  @media (max-width: 1250px) {
    max-width: 100%;
    min-width: 305px;
  }
  @media (max-width: 718px) {
    padding: 0;
  }
`;
export const SearchContainer = styled.div`
  width: 100%;
  max-width: 1411px;
  padding: 0 85px;
  margin: 0 auto;
  display: flex;
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
`;
export const AdvanceSearchDiv = styled.div`
  border-radius: 5px;
  background: #61b01f;
  background: -moz-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: -webkit-linear-gradient(top, #61b01f 0%, #27911b 100%);
  background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#61b01f', endColorstr='#27911b',GradientType=0 );
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  min-width: 161px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  cursor: pointer;
  font-family: "latobold";
  @media (max-width: 718px) {
    text-align: center;
  }
`;
export const DropDownDiv = styled.div`
  border-radius: 10px;
  .custom-select__control {
    height: 37px;
    border-radius: 5px;
    border: solid 1px #87cdf1;
  }
`;
export const BlankSection = styled.div`
  min-width: 200px;
  padding: 0 20px;
  @media (max-width: 1250px) {
    display: none;
  }
`;

export const UserDropDown = styled.div`
  :before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: #fff;
    position: absolute;
    z-index: 3;
    bottom: -8px;
    transform: rotateZ(45deg);
    right: 9px;
    border-left: solid 1px #87cdf1;
    border-top: solid 1px #87cdf1;
  }
`;